import { ToLocaleTimeBaseValueConverter } from 'General/Resources/ValueConverters/ToLocaleTimeBase';
export class ToLocaleTimeValueConverter extends ToLocaleTimeBaseValueConverter {

}